import { useCallback, useEffect, useMemo } from "react";
import { IUser } from "@/common/services/types";
import { IUserInfo } from "components/widgets/types";
import { useSfw } from "@/common/hooks/useSfw";
import { apiCreators } from "@/common/services";
import { useTendingCreatorsStore } from "@/common/store/trendingCreatorsStore";
import { useUsersStore } from "@/common/store/storeUsers";
import { useFetch } from "./useFetch";

export const useTrendingUsers = () => {
  const { sanitizeUser, isLoading } = useSfw();
  const ids = useTendingCreatorsStore((state) => state.ids);
  const setIds = useTendingCreatorsStore((state) => state.setIds);
  const updateUsers = useUsersStore((state) => state.updateUsers);
  const getUser = useUsersStore((state) => state.getUser);

  const fetchTrendingUsers = useCallback(() => apiCreators.getTrendingCreators(), []);
  const { isLoading: creatorsLoading, error, data } = useFetch(fetchTrendingUsers, !ids.length);

  useEffect(() => {
    if (!error && data) {
      updateUsers(data.items);
      setIds(data.items.map((el: IUser) => el.username));
    }
  }, [error, data, updateUsers, setIds]);

  const creators = useMemo(() => {
    const creators: IUserInfo[] = [];

    ids.forEach(id => {
      const creator = getUser(id);

      if (creator) {
        const user = sanitizeUser(creator);

        creators.push({
          id: user.username,
          name: user.name ?? user.username,
          image: user.profileImageUrl ?? undefined,
          verified: user.verified,
        });
      }
    });

    return creators;
  }, [ids, getUser]);

  return {
    creators,
    creatorsLoading,
    error,
    isLoading,
  };
};
